export default "__VITE_ASSET__DN8Jwms7__"